import ReactMarkdown from "react-markdown";
import remarkBreaks from "remark-breaks";
import './TeamPage.css';

const TeamPage = () => {
    const phDStudents = [
        { 
            name: 'Younggeun Lee', 
            img: process.env.PUBLIC_URL + '/team/YGL.jpeg',
            desc: 'MS-PhD Integrated Student\nIntern at [CJ 4DPLEX](https://www.cj4dplex.com/)',
            email: 'dudrms514@skku.edu', 
            scholar: 'https://scholar.google.com/citations?hl=en&user=E4iEBFsAAAAJ',
            github: 'https://github.com/Younggeun-L' 
        },
        { 
            name: 'Seungtae Nam', 
            img: process.env.PUBLIC_URL + '/team/STN.png',
            desc: 'PhD Student\nIntern at [Microsoft \nResearch Asia](https://www.microsoft.com/en-us/research/lab/microsoft-research-asia/)',
            email: 'stnamjef@yonsei.ac.kr', 
            scholar: 'https://scholar.google.com/citations?user=8NKPmmwCmrAC&hl=en',
            github: 'https://github.com/stnamjef'
        },
        { 
            name: 'Byeonghyeon Lee', 
            img: process.env.PUBLIC_URL + '/team/BHL.jpg', 
            desc: 'PhD Student',
            email: 'bhl@yonsei.ac.kr', 
            scholar: 'https://scholar.google.com/citations?user=_PhPccYAAAAJ&hl=en',
            github: 'https://github.com/benhenryL' 
        },
        { 
            name: 'Younghyun Kim', 
            img: process.env.PUBLIC_URL + '/team/YHL.jpg',
            desc: 'PhD Student',
            email: 'yhyun225@yonsei.ac.kr', 
            scholar: 'https://scholar.google.com/citations?hl=en&user=4M-6X7MAAAAJ',
            github: 'https://github.com/yhyun225'  
        },
        { 
            name: 'Minseo Lee', 
            img: process.env.PUBLIC_URL + '/team/MSL.jpg',
            desc: 'MS-PhD Integrated Student',
            email: 'lms@yonsei.ac.kr', 
            scholar: '',
            github: 'https://github.com/MinShirley'   
        },
        { 
            name: 'Jungwoo Kim', 
            img: process.env.PUBLIC_URL + '/team/JWK.jpeg',
            desc: 'MS-PhD Integrated Student',
            email: 'jungwkim@yonsei.ac.kr',
            scholar: '',
            github: 'https://github.com/jungcow'   
        },
        { 
            name: 'Hyun-kyu Ko', 
            img: process.env.PUBLIC_URL + '/team/HKK.jpg',
            desc: 'PhD Student\nVisiting Student at [UC Irvine](https://uci.edu/)',
            email: 'laniko@yonsei.ac.kr', 
            homepage: 'https://ko-lani.github.io/',
            scholar: 'https://scholar.google.com/citations?hl=ko&user=lsi-8-QAAAAJ',
            github: 'https://github.com/Ko-Lani'  
        },
        { 
            name: 'Byeongjin Kang', 
            img: process.env.PUBLIC_URL + '/team/BJK.jpg',
            desc: 'MS-PhD Integrated Student\nIntern at [KETI](https://www.keti.re.kr/main/main.php)',
            email: 'namul2@yonsei.ac.kr',
            homepage: 'https://namul2.github.io/',
            scholar: '',
            github: 'https://github.com/Namul2'   
        },
        { 
            name: 'Minjun Kim', 
            img: process.env.PUBLIC_URL + '/team/MJK.jpg',
            desc: 'MS-PhD Integrated Student',
            email: 'mnjnmkmn@yonsei.ac.kr',
            github: 'https://github.com/greentiramisu'   
        },
        { 
            name: 'Woonho Ko', 
            img: process.env.PUBLIC_URL + '/team/WHK.jpeg',
            desc: 'PhD Student',
            email: 'heesuk9898@yonsei.ac.kr',
            scholar: 'https://scholar.google.com/citations?user=bl538r8AAAAJ',
            github: 'https://github.com/kowoonho'   
        },
        { 
            name: 'Minhyeok Roh', 
            img: process.env.PUBLIC_URL + '/team/MHR.jpg',
            desc: 'MS-PhD Integrated Student',
            email: 'mhroh01@yonsei.ac.kr', 
            scholar: '',
            github: 'https://github.com/minhyeok2001'   
        },
        { 
            name: 'Hyebin Kim', 
            img: process.env.PUBLIC_URL + '/team/HBK.jpg',
            desc: 'PhD Student',
            email: 'hyebinny5600@gmail.com', 
            scholar: '',
            github: 'https://github.com/hyebinny'   
        },
    ];

    const masterStudents = [
        { 
            name: 'Seungkwon Yang', 
            img: process.env.PUBLIC_URL + '/team/SKY.jpg',
            desc: 'MS Student',
            email: 'skyang@yonsei.ac.kr', 
            scholar: '',
            github: 'https://github.com/yang-gwon2'
        },
        { 
            name: 'Jinho Park', 
            img: process.env.PUBLIC_URL + '/team/JHP.jpeg',
            desc: 'MS Student',
            email: 'jinho99@g.skku.edu', 
            scholar: '',
            github: 'https://github.com/zinosii'
        },
        { 
            name: 'Woojeong Baek', 
            img: process.env.PUBLIC_URL + '/team/WJB.jpeg',
            desc: 'MS Student', 
            email: 'bwj2800@yonsei.ac.kr',
            scholar: 'https://scholar.google.com/citations?user=-1yRZjYAAAAJ',
            github: 'https://github.com/bwj2800'   
        },
        { 
            name: 'Joonhyuk Park', 
            img: process.env.PUBLIC_URL + '/team/JoonhyukPark.jpg',
            desc: 'MS Student',
            email: 'rchkl2380@yonsei.ac.kr', 
            scholar: '',
            github: 'https://github.com/joonh-park'   
        },
        { 
            name: 'Hwasik Jeong', 
            img: process.env.PUBLIC_URL + '/team/HSJ.jpg',
            desc: 'MS Student',
            email: '99hwasikk@yonsei.ac.kr', 
            scholar: '',
            github: 'https://github.com/HwasikJeong'   
        },
        { 
            name: 'Soonmin Hwang', 
            img: process.env.PUBLIC_URL + '/team/SMH.JPG',
            desc: 'MS Student\nIntern at [KETI](https://www.keti.re.kr/main/main.php)',
            email: 'smsm0307@yonsei.ac.kr', 
            scholar: 'https://scholar.google.com/citations?hl=ko&user=IjfOwv4AAAAJ',
            github: 'https://github.com/smblue37'   
        }
    ];

    const undergraduateStudents = [
        
    ];

    const alumni = [
        { 
            name: 'Daniel Rho', 
            desc: 'MS, 2020.09 - 2022.08 (co-advised by Jong Hwan Ko)',
            current: 'PhD student at UNC Chapel Hill',
            homepage: 'https://daniel03c1.github.io/'
        },
        { 
            name: 'Hanbit Yoon',
            desc: 'MS, 2021.09 - 2023.08 (co-advised by Joon Hee Choi)',
            current: 'Samsung Electronics'
        },
        { 
            name: 'Sanghyeon Kim', 
            desc: 'MS, 2021.09 - 2023.08',
            current: 'LG CNS'
        },
        { 
            name: 'Junwoo Cho',
            desc: 'MS, 2021.09 - 2023.08', 
            current: 'Lunit'
        },
        { 
            name: 'Usman Ali', 
            desc: 'Research Professor, 2022.09 - 2024.02', 
            current: 'Assistant Professor at Sejong University'
        },
        { 
            name: 'Seungtae Nam',
            desc: 'MS, 2022.03 - 2024.02', 
            current: 'PhD student at V-Lab, Yonsei'
        },
        { 
            name: 'Hyunmo Yang', 
            desc: 'MS, 2022.03 - 2024.02',
            current: 'Inbody'
        },
        { 
            name: 'Byeonghyeon Lee', 
            desc: 'MS, 2022.09 - 2024.08', 
            current: 'PhD student at V-Lab, Yonsei'
        },
        { 
            name: 'Howoong Lee', 
            desc: 'MS, 2022.09 - 2024.08 (Industrial Scholars Program)', 
            current: 'Hanwha Vision'
        },
        { 
            name: 'Youngin Park', 
            desc: 'MS, 2023.03 - 2024.08 (Part-time Industrial Scholars Program)',
            current: 'Samsung Electronics'
        },
        { 
            name: 'Younghyun Kim', 
            desc: 'MS, 2023.03 - 2025.02',
            current: 'PhD student at V-Lab, Yonsei'
        },
        { 
            name: 'Dohyun Kim', 
            desc: 'MS, 2023.03 - 2025.02',
            current: 'Samsung Electronics'
        },
        { 
            name: 'Geunmin Hwang', 
            desc: 'MS, 2023.03 - 2025.02',
            current: 'Krafton'
        },
        { 
            name: 'Seungjun Oh', 
            desc: 'MS, 2023.09 - 2025.08',
            current: 'Hanwha Vision'
        },
        { 
            name: 'Namgyu Kang', 
            desc: 'MS, 2022.03 - 2024.08 / PhD, 2024.09 - 2025.08',
            current: 'PhD student at Yonsei Quantum Computing Group, Yonsei'
        },
        { 
            name: 'Dongheok Park', 
            desc: 'MS, 2024.03 - 2026.02',
            current: 'POSCO DX' 
        },
        { 
            name: 'Hyun-kyu Ko', 
            desc: 'MS, 2024.03 - 2026.02',
            current: 'PhD student at V-Lab, Yonsei'
        },
        { 
            name: 'Jisang Yoo',
            desc: 'MS, 2024.03 - 2026.02',
            current: 'Hyundai Motor Company'
        },
        { 
            name: 'Hyejin Jeon', 
            desc: 'MS, 2024.03 - 2026.02',
            current: 'Samsung Electronics' 
        },
        { 
            name: 'Gyeongjin Kang',
            desc: 'MS, 2024.03 - 2026.02',
            current: 'Researcher at V-Lab, Yonsei',
            homepage: 'https://gynjn.github.io/info/' 
        },
        { 
            name: 'Joo Chan Lee', 
            desc: "PhD, 2020.03 - 2026.08 (co-advised by Jong Hwan Ko)",
            current: 'Samsung Research', 
            homepage: 'https://maincold2.github.io/',
        },
        { 
            name: 'Xiangyu Sun', 
            desc: 'PhD, 2022.09 - 2026.08',
            current: 'Horizon Robotics',             
        },
        { 
            name: 'Youbin Kim', 
            desc: 'MS, 2024.09 - 2026.08',
            current: 'Samsung Electronics',  
        },
        { 
            name: 'Jihyeon Park', 
            desc: 'MS, 2024.09 - 2026.08',
            current: 'Samsung Electronics',  
        },
        { 
            name: 'Seungryong Lee', 
            desc: 'MS, 2024.09 - 2026.08',
            current: 'Samsung Electronics',  
        },
        { 
            name: 'Eunsoo Lee', 
            desc: 'MS, 2024.09 - 2026.08',
            current: 'Samsung Electronics',  
        },
        { 
            name: 'Junyu Zhang', 
            desc: 'PhD, 2023.09 - 2026.08',
            current: 'PostDoc at SNU',
            
        },
    ];

    return (
        <div className="team-page">
            <section>
                <h2>Principal Investigator</h2>
                <div className="profile">
                    <div className="member">
                        <img
                            src={process.env.PUBLIC_URL + '/team/epark3.jpg'}
                            alt="Prof. Eunbyung Park"
                            className="profile-img"
                        />
                        <a className='prof-name' href='https://silverbottlep.github.io/' style={{ fontSize: '1em' }}>Eunbyung Park</a>
                        <div className='bio'>
                                <a href="mailto:epark@yonsei.ac.kr">
                                    <i className="fa fa-envelope-o" style={{ fontSize: '24px', color: 'black' }}></i>
                                </a>
                                <a href="https://silverbottlep.github.io/index.html">
                                    <i className="fa fa-home" style={{ fontSize: '24px', color: 'black' }}></i>
                                </a>
                                <a href="https://scholar.google.com/citations?user=iPyuJmQAAAAJ&hl=en">
                                    <i className="ai ai-google-scholar" style={{ fontSize: '24px', color: 'black' }}></i>
                                </a>
                                <a href="https://www.linkedin.com/in/eunbyung-park-286384b4/">
                                    <i className="fa fa-linkedin" style={{ fontSize: '24px', color: 'black' }}></i>
                                </a>
                                <a href="https://x.com/silverbottlep">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="black">
                                        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.73-8.835L1.254 2.25H8.08l4.26 5.632 5.904-5.632Zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                                    </svg>
                                </a>
                            </div>
                    </div>
                </div>
            </section>


            <section>
                <h2>Ph.D. Students</h2>
                <div className="students">
                    {phDStudents.map((student, index) => (
                        <div key={index} className="member">
                            <img src={student.img} alt={student.name} className="profile-img" />
                            <p>{student.name}</p>
                            <div className="student-links">
                                {student.email && <a href={`mailto:${student.email}`}><i className="fa fa-envelope-o" style={{ fontSize: '24px', color: 'black' }}></i></a>}
                                {student.homepage && <a href={student.homepage}><i className="fa fa-home" style={{ fontSize: '24px', color: 'black' }}></i></a>}
                                {student.scholar && <a href={student.scholar}><i className="ai ai-google-scholar" style={{ fontSize: '24px', color: 'black' }}></i></a>}
                                {student.github && <a href={student.github}><i className="fa fa-github" style={{ fontSize: '24px', color: 'black' }}></i></a>}
                            </div>
                            <div id="desc">
                                <ReactMarkdown remarkPlugins={[remarkBreaks]}>
                                    {
                                    student.desc.replace(/\r\n/g, "\n").replace(/\\n/g, "\n")
                                    }
                                </ReactMarkdown>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            <section>
                <h2>Master Students</h2>
                <div className="students">
                    {masterStudents.map((student, index) => (
                        <div key={index} className="member">
                            <img src={student.img} alt={student.name} className="profile-img" />
                            <p>{student.name}</p>
                            <div className="student-links">
                                {student.email && <a href={`mailto:${student.email}`}><i className="fa fa-envelope-o" style={{ fontSize: '24px', color: 'black' }}></i></a>}
                                {student.homepage && <a href={student.homepage}><i className="fa fa-home" style={{ fontSize: '24px', color: 'black' }}></i></a>}
                                {student.scholar && <a href={student.scholar}><i className="ai ai-google-scholar" style={{ fontSize: '24px', color: 'black' }}></i></a>}
                                {student.github && <a href={student.github}><i className="fa fa-github" style={{ fontSize: '24px', color: 'black' }}></i></a>}
                            </div>
                            <div id="desc">
                                <ReactMarkdown remarkPlugins={[remarkBreaks]}>
                                    {
                                    student.desc.replace(/\r\n/g, "\n").replace(/\\n/g, "\n")
                                    }
                                </ReactMarkdown>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* <section>
                <h2>Undergraduate Students</h2>
                <div className="students">
                    {undergraduateStudents.map((student, index) => (
                        <div key={index} className="member">
                            <img src={student.img} alt={student.name} className="profile-img" />
                            <p>{student.name}</p>
                            <div className="student-links">
                                {student.email && <a href={`mailto:${student.email}`}><i className="fa fa-envelope-o" style={{ fontSize: '24px', color: 'black' }}></i></a>}
                                {student.scholar && <a href={student.scholar}><i className="ai ai-google-scholar" style={{ fontSize: '24px', color: 'black' }}></i></a>}
                                {student.github && <a href={student.github}><i className="fa fa-github" style={{ fontSize: '24px', color: 'black' }}></i></a>}
                            </div>
                        </div>
                    ))}
                </div>
            </section> */}


            <section>
                <h2>Alumni</h2>
                <div className="alumni">
                    {alumni.map((alumnus, index) => (
                        <div key={index} className="alumnus">
                            <p className="alumnus-info">
                                <span className="name">
                                    {alumnus.homepage ? (
                                        <a href={alumnus.homepage} target="_blank" rel="noopener noreferrer">
                                            {alumnus.name}
                                        </a>
                                    ) : (
                                        alumnus.name
                                    )}
                                </span>
                                <span className="desc">{alumnus.desc}</span>
                                <span className="current">{alumnus.current}</span>
                            </p>
                        </div>
                    ))}
                </div>
            </section>
        </div>
    );
};

export default TeamPage;
